<template>
  <div
    class="header z-40 in-top"
    id="header"
    :class="[defaultColor, { bannermargin: isBanner }]"
  >
    <banner-header :banner="banner"></banner-header>
    <div class="header-container im-in-home">
      <button
        @click="openMenu"
        class="button-hamburger block xl:hidden"
        :class="'white'"
      >
        <div></div>
        <div></div>
        <div></div>
      </button>
      <div class="header-logo flex justify-center items-center">
        <a :href="routes.home">
          <img
            class="logo-humboldt"
            :src="'/img/logo-' + 'white' + '.svg'"
            alt=""
          />
        </a>
        <div v-if="!shortContent" class="header-links xl:flex justify-center items-center hidden">
        <a
          class="nv-link hidden lg:block font-bold ml-8 xl:ml-16"
          :href="routes['shop'] + '/feminized-seeds'"
          >{{
          trans.get("layouts.header.feminized")
        }}</a
        >
        <a class="nv-link hidden lg:block font-bold" :href="routes['shop'] + '/autoflower-seeds'">{{
          trans.get("layouts.header.autoflower")
        }}</a>
        <a class="nv-link hidden lg:block font-bold" :href="routes['shop'] + '/seed-collective'">{{
          trans.get("layouts.header.regular")
        }}</a>
        <a v-if="hasActiveDiscounts" class="nv-link hidden lg:block font-bold" :href="routes['shop'] + '/offers'">{{
          trans.get("layouts.header.offers")
        }}</a>
        <a class="nv-link hidden lg:block font-bold" :href="routes['merchandise']">{{
          trans.get("layouts.header.our-merch")
        }}</a>
        <a class="nv-link hidden lg:block font-bold" :href="routes['stores']">{{
          trans.get("layouts.header.stores")
        }}</a>
        <a class="seed-link hidden lg:block font-bold nv-link" :href="routes['find-your-seed']">{{
          trans.get("layouts.header.find-your-seed")
        }}</a>
      </div>
      </div>
      <div v-if="!shortContent" class="header-links  justify-center items-center hidden xl:mr-64">
        <a
          class="nv-link hidden lg:block font-bold"
          :href="routes['shop'] + '/feminized-seeds'"
          >{{
          trans.get("layouts.header.feminized")
        }}</a
        >
        <a class="nv-link hidden lg:block font-bold" :href="routes['shop'] + '/autoflower-seeds'">{{
          trans.get("layouts.header.autoflower")
        }}</a>
        <a class="nv-link hidden lg:block font-bold" :href="routes['shop'] + '/seed-collective'">{{
          trans.get("layouts.header.regular")
        }}</a>
        <a class="nv-link hidden lg:block font-bold" :href="routes['shop'] + '/offers'">{{
          trans.get("layouts.header.offers")
        }}</a>
        <a class="nv-link hidden lg:block font-bold" :href="routes['merchandise']">{{
          trans.get("layouts.header.our-merch")
        }}</a>
      </div>

      <div v-else class="header-links flex items-center ">
        <a class="nv-link hidden lg:block" :href="routes.contact">{{
          trans.get("layouts.header.support")
        }}</a>
        <a class="language-selector-link nv-link hidden lg:flex relative">
          <span class="capitalize">{{ lang }}</span>
          <img class="ml-1 w-5" :src="'/img/icons/arrow_down-' + 'white' + '.svg'" />
          <div class="language-selector absolute rounded">
            <slot name="language-selector"> </slot>
          </div>
        </a>
      </div>

      <div class="header-links flex justify-center items-center" v-if="!shortContent">
        <a
          v-if="user"
          :href="routes['customer-area']"
          class="nv-link user-icon flex flex-col justify-center items-center"
          ><img :src="'/img/icons/user-' + 'white' + '.svg'" alt="" /><span
            class=""
            >{{ user.name }}</span
          ></a
        >
        <a
          v-else
          class="nv-link user-icon "
          :href="routes['register']"
        >
          <img :src="'/img/icons/user-' + 'white' + '.svg'" alt="" />
        </a>
        <a class="nv-link cart-icon" :href="routes.checkout">
          <img :src="'/img/icons/bag-' + 'white' + '.svg'" alt="" />
          <cart-count :load-cart="false"></cart-count>
        </a>
        <a class="language-selector-link nv-link hidden lg:flex relative">
            <span class="capitalize">{{ lang }}</span>
          <img class="ml-1 w-5" :src="'/img/icons/arrow_down-' + 'white' + '.svg'" />
          <div class="language-selector absolute rounded">
            <slot name="language-selector"> </slot>
          </div>
        </a>
      </div>

    </div>
    <side-menu :is-active="isActive" :close-menu="closeMenu" :isRight="false">
      <side-menu-content :hasActiveDiscounts="hasActiveDiscounts" :routes="routes" :username="user && user.name" :close-menu="closeMenu">
        <template v-slot:language-selector-mobile>
          <slot name="language-selector-mobile"></slot>
        </template>
      </side-menu-content>
      <cart-count hidden></cart-count>
    </side-menu>
  </div>
</template>

<script>
import axios from 'axios'
const blackAsDefault = ['shop', 'merchandise', 'contact', 'about', 'legal', 'stores', 'checkout', 'wizard']
import SideMenu from './SideMenu'
import SideMenuContent from './SideMenuContent'
import BannerHeader from '../BannerHeader.vue'
import CartCount from '../../components/cart/CartCount'
import mixin from '../../mixin'

export default {
  mixins: [mixin],
  components: {
    SideMenu,
    SideMenuContent,
    CartCount,
    BannerHeader,
  },
  props: {
    routes: {
      type: Object,
      required: true,
    },
    currentRoute: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    },
    shortContent: {
      default: false,
    },
    isMerch: {
      default: true,
    },
    hasActiveDiscounts: {
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {
      lastScroll: 0,
      defaultColor: null,
      currentcolor: 'white',
      isActive: false,
      delta: 30,
      banner: {},
    }
  },
  computed: {
    isBanner() {
      return Object.keys(this.banner).length != 0
    },
  },
  created() {
    const isErrorPage = document.querySelector('.error-page') !== null;
    const defaultColor = blackAsDefault.includes(this.currentRoute) || this.isMerch.type === 'merch' || isErrorPage ? 'black' : 'white';
    this.defaultColor = this.currentcolor = defaultColor
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted() {
    if (this.shortContent) {
      const header = document.getElementById('header')
      header.classList.add('background-header-white')
    }
  },
  beforeMount() {
    axios
      .get('/api/banners')
      .then((res) => {
        this.banner = { ...res.data }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    openMenu() {
      this.isActive = true
    },
    closeMenu() {
      this.isActive = false
    },
    handleScroll(event) {
      const scrollUp = 'scroll-up'
      const scrollDown = 'scroll-down'
      const top = 'in-top'
      const currentScroll = window.pageYOffset
      const header = document.getElementById('header')
      if (currentScroll <= 0) {
        //in top
        this.currentcolor = 'white'
        header.classList.remove(scrollUp)
        header.classList.add(top)
        return
      }
      if (currentScroll > this.lastScroll && !header.classList.contains(scrollDown) && currentScroll > this.delta) {
        // scrolling down
        this.currentcolor = 'black'
        header.classList.remove(scrollUp)
        header.classList.remove(top)
        header.classList.add(scrollDown)
      } else if (currentScroll < this.lastScroll && header.classList.contains(scrollDown)) {
        // scrolling up
        this.currentcolor = 'white'
        header.classList.remove(scrollDown)
        header.classList.remove(top)
        header.classList.add(scrollUp)
      }
      this.lastScroll = currentScroll
    },
  },
}
</script>
<style lang="scss">
@import "../../../sass/variables";

.header {
  height: 64px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  transition: transform 0.4s;
  background-color: transparent;
  z-index: 10000;
  will-change: background-color;
  @media (min-width: 1024px) {
    height: 66px;
  }
  &.bannermargin {
    height: 105px;
    @media (max-width: $breakpoint-landing-phone) {
      height: 98px;
    }
  }
  .header-logo {
    margin-left: 3.25rem;
     @media (min-width: 1024px) {
        margin-left: 0;
      }
    .logo-humboldt {

      width: 100px;
      height: 50px;
      @media (min-width: 1024px) {
        width: 140px;
      }
    }
  }

  .header-links {
    .cart-icon {
      position: relative;
      margin-right: 1rem;
      @media (min-width: 1024px) {
        margin-right: 1.5rem;
      }
    }
    .language-selector-link {
      cursor: pointer;
      margin-bottom: -0.5rem;
      padding-bottom: 0.5rem;
      img {
        transition: transform 0.3s ease-out;
      }
      .language-selector {
        visibility: hidden;
        opacity: 0;
        top: 100%;
        left: 0;
        transition: opacity 0.3s ease;
        background-color: $primary;
        left: 50%;
        transform: translateX(-50%);
        box-shadow: 0 0 5px 0 #aaa;
        &-item {
          a {
            padding: 1rem 2rem;
            color: $secondary !important;
            display: block;
          }
          &:hover {
            background: darken($primary, 7.5%);
          }
        }
      }

      &:hover {
        .language-selector {
          opacity: 1;
          visibility: visible;
        }
        img {
          transform: rotate(180deg);
        }
      }
    }
  }
  &-container {
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    padding: 0 1rem;
    font-size: 16px;
    line-height: 1.5;
    max-width: 1600px;
    @media (min-width:1024px) {
      height: 66px;
      padding: 0 2rem;
    }
    @media (min-width:$breakpoint-landing-tablet) {
      height: 66px;
      padding: 0 4.25rem;
    }
    &.im-in-home {
      color: white;
      a {
        color: white;
        text-decoration: none;
      }
    }

    .seed-link {
      color: $yellow !important;
    }

    .nv-link {
      margin-right: 1rem;
      @media (min-width: 1024px) {
        margin-right: 1.5rem;
      }
      &.user-icon {
        img {
          width: 22px;
          height: auto;
        }
      }
      &.cart-icon {
        img {
          width: 24px;
          height: auto;
        }
      }
    }
  }
  &.scroll-down {
    transform: translate3d(0, -200%, 0);
    background-color: #f4f3ed;
    color: black;
    transition: 0.5s;
    a {
      color: black;
    }
  }
  &.scroll-up {
    transform: none;
    color: white;
    background-color: #1d241e;
    transition: 0.5s;
    a {
      color: white;
    }
  }
  &:not(.scroll-up):not(.scroll-down).black {
    transform: none;
    color: white;
    background-color: #1d241e;
    transition: 0.5s;
    a {
      color: white;
    }
  }

  .button-hamburger {
    div {
      width: 27px;
      height: 2px;
      margin: 6px 0;
    }
    &.white div {
      background-color: white;
    }
    &.black div {
      background-color: black;
    }
  }
}

.bannermargin {
  height: 110px;
}

.background-header-white {
  background-color: #1d241e !important;
}
</style>
